import { useTranslation } from 'react-i18next'

import placeholder from 'src/assets/avatar-placeholder.png'

export function Avatar(props: { className?: string; src?: string | null }) {
  const { t } = useTranslation()
  const avatar = props.src ?? placeholder

  return (
    <img
      className={props.className}
      src={avatar}
      alt={t('common:avatar_alt')}
    />
  )
}
